// @vendors
const Immutable = require('immutable');

// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = () => {
    return Immutable.Map().merge({
        contractsIntervention: Immutable.Map(),
        contractView: null,
        error: false,
        isFetching: false,
        waitingCustomWalletviewInterveners: false,
    });
};

function addContract(contractId, list, contracts) {
    return contracts.set(contractId, 
        Immutable.fromJS({ 
            interventionType: null,
            interveners: list,
            isLoaded: true,
        })
    );
}

function processCustomWalletInterveners(state, data, contractId){
    const intervenersData = data.dato;
    const listContract = state.get('contractsIntervention');
    let list = [];

    intervenersData.forEach((type) => {
        const nomInterviniente = type.nombre;
        const tipoIntervencion = type.desIntervencion;

        const newItem = list.filter((item) => item.interventionType === tipoIntervencion );
        if (newItem.length > 0) {
            const typeItem = newItem[0].interventionType;
            const nameItem = newItem[0].nameInterveners;
            
            list = list.filter((item) => item.interventionType !== tipoIntervencion);
            nameItem.push(nomInterviniente);
            
            const item = {
                interventionType: typeItem,
                nameInterveners: nameItem
            }

            list.push(item);} 
        else {
            const item = {
                interventionType: tipoIntervencion,
                nameInterveners: [ nomInterviniente ],
            }
            list.push(item);
        }
    });

    if (!listContract.get(contractId)) {
        return state.merge( Immutable.fromJS({
            contractsIntervention: addContract(contractId, list, listContract),
            isFetching: false
        }));
    }
    else {
        return state.updateIn(['contractsIntervention',contractId], (intervener) => {
            return intervener.set('interveners', Immutable.fromJS(list)).set('isLoaded',true)
        }).set('isFetching', false);
    }
}

function interventionTypeByContract(payload) {
    let byId = {};
    
    payload.contracts.forEach((immContract) => {
        immContract.valores.forEach((contract) => {
            const id = contract.fullContrato;
            const interventionType = contract.tipoIntervencion;
            byId[id] = {
                interventionType: interventionType,
                interveners: Immutable.Map(),
                isLoaded: false,
            }
        });
    });
    return byId;
}

function brokerCustomWalletInterveners(state = initialState(), action) {
    switch (action.type) {
        case actionTypes.BROKER_GET_MY_INVESTMENTS_SUCCESS:
            return state.merge({
                contractsIntervention: interventionTypeByContract(action.payload)
            });
        case actionTypes.BROKER_CUSTOM_WALLET_VIEW_INTERVENERS_CANCELED:
            return state.merge({
                waitingCustomWalletviewInterveners: false,
                contractView: null,
                error: false,
            });
        case actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_VIEW_CONTRACT:
            return state.merge({
                contractView: action.contract
            });
        case actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_SUCCESS:
            return processCustomWalletInterveners(state, action.payload.data, action.payload.contract);
        case actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_REQUEST:
            return state.merge({
                isFetching: true,
                waitingCustomWalletviewInterveners: true,
            });
        case actionTypes.BROKER_CUSTOM_WALLET_VIEW_INTERVENERS_DISPLAY_MODAL:
            return state.merge({
                waitingCustomWalletviewInterveners: true,
            });
        case actionTypes.BROKER_CUSTOM_WALLET_INTERVENERS_ERROR:
            return state.merge({
                error: true,
                isFetching: false
            });
        default:
            return state;
    }
}

module.exports = brokerCustomWalletInterveners;
